import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { useIntl } from 'react-intl'
import { PaginationBar } from 'mailup-web-components'

import { paginationState } from 'Pages/AbTestList/recoil/state/search'
import { resultsState } from 'Pages/AbTestList/recoil/state/results'

const Pagination = () => {
  const intl = useIntl()

  const { pageNum, pageSize } = useRecoilValue(paginationState)
  const { totalItems } = useRecoilValue(resultsState)
  const setState = useSetRecoilState(paginationState)

  const handleChange = pageNum => {
    setState(prev => ({
      ...prev,
      pageNum
    }))
  }

  const handleChangePageSize = pageSize => {
    setState(prev => ({
      ...prev,
      pageNum: 1,
      pageSize
    }))
  }

  return (
    <PaginationBar
      pageNumber={pageNum}
      pageSize={pageSize}
      minPageSize={5}
      handleChangePage={handleChange}
      handleChangePageSize={handleChangePageSize}
      totalItems={totalItems}
      data-mu-test='pager'
      strings={{
        of: intl.formatMessage({ id: 'Load.Pager.Of' }),
        label: intl.formatMessage({ id: 'Load.Pager.Items' })
      }}
    />
  )
}

export default Pagination
